import { Type, type Static } from '@sinclair/typebox';

export const HostedAuthDomainBodySchema = Type.Object(
  {
    cname: Type.String({ minLength: 1, maxLength: 253 }),
  },
  { additionalProperties: false },
);

export type HostedAuthDomainBody = Static<typeof HostedAuthDomainBodySchema>;
